module.exports = __webpack_public_path__ + "img/liberia.d3e6ee2.webp";